// src/App.jsx
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Layout from "./Layout";
import Dashboard from "./components/Dashboard";
import Profile from "./components/Profile";
import Transactions from "./components/Transactions";
import Earnings from "./components/Earnings";
import Packages from "./components/Packages";
import Deposit from "./components/Deposit";
import Withdraw from "./components/Withdraw";
import Settings from "./components/Settings";
import AffiliateDashboard from "./components/AffiliateDashboard";
import AffiliateLogin from "./components/AffiliateLogin";
import AffiliateSignup from "./components/AffiliateSignup";
import Login from "./components/Login";
import Signup from "./components/Signup";
import KYC from "./components/KYC";
import InternalTransfer from "./components/InternalTransfer";

import { SupabaseAuthProvider, useAuth } from "./contexts/SupabaseAuthProvider";
import { UserDataProvider } from "./contexts/UserDataProvider";
import { SettingsProvider } from "./contexts/SettingsProvider";

/* 🔒 SAME FILE – SIMPLE PROTECTION */
function ProtectedLayout() {
  const { user, loading } = useAuth();

  if (loading) return null; // ya loader

  if (!user) {
    return <Navigate to="/signup" replace />;
  }

  return <Layout />;
}

export default function App() {
  return (
    <SupabaseAuthProvider>
      <UserDataProvider>
        <SettingsProvider>
          <BrowserRouter>
            <Routes>

              {/* ================= AUTH ================= */}
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />

              {/* ============ AFFILIATE AUTH (SEPARATE) ============ */}
              <Route path="/affiliate/login" element={<AffiliateLogin />} />
              <Route path="/affiliate/signup" element={<AffiliateSignup />} />

              {/* ============ AFFILIATE PANEL (SEPARATE) ============ */}
              <Route
                path="/affiliate/dashboard"
                element={<AffiliateDashboard />}
              />

              {/* ============ NORMAL APP (WITH LAYOUT) ============ */}
             <Route element={<ProtectedLayout />}>
  <Route path="/" element={<Dashboard />} />
  <Route path="/profile" element={<Profile />} />
  <Route path="/transactions" element={<Transactions />} />
  <Route path="/packages" element={<Packages />} />
  <Route path="/earnings" element={<Earnings />} />
  <Route path="/deposit" element={<Deposit />} />
  <Route path="/withdraw" element={<Withdraw />} />
  <Route path="/internal-transfer" element={<InternalTransfer />} /> {/* ✅ */}
  <Route path="/settings" element={<Settings />} />
  <Route path="/kyc" element={<KYC />} />
</Route>

            </Routes>
          </BrowserRouter>
        </SettingsProvider>
      </UserDataProvider>
    </SupabaseAuthProvider>
  );
}
